module.exports = __webpack_public_path__ + "img/presidentpic.0bdcb1d6.png";